export default __webpack_public_path__ + "static/media/dryfig.25825627.jpg";